import { combineReducers } from '@reduxjs/toolkit';

import { sellBike } from './core/sellBike';
import { sellCar } from './core/sellCar';
import { sellCommercial } from './core/sellCommercial';

import { archiveList } from './base/archiveList';
// import getBasePoliceList from './base/getBasePoliceList';

import {
    bikeAll,
    bikeAllList,
    bikeNoAccount,
    bikeNoAccountList,
    carAll,
    carAllList,
    carNoAccount,
    carNoAccountList,
    commercialAll,
    commercialAllList,
    commercialNoAccount,
    commercialNoAccountList,
} from './all';

export default combineReducers({
    sellBike,
    sellCar,
    sellCommercial,

    archiveList,
    // getBasePoliceList,

    bikeAll,
    bikeAllList,
    carAll,
    carAllList,
    commercialAll,
    commercialAllList,
    carNoAccountList,
    carNoAccount,
    bikeNoAccountList,
    bikeNoAccount,
    commercialNoAccountList,
    commercialNoAccount,
});
